import { render, staticRenderFns } from "./CourtesyEmitterResponsible.vue?vue&type=template&id=24fce7aa&scoped=true"
import script from "./CourtesyEmitterResponsible.vue?vue&type=script&lang=js"
export * from "./CourtesyEmitterResponsible.vue?vue&type=script&lang=js"
import style0 from "./CourtesyEmitterResponsible.vue?vue&type=style&index=0&id=24fce7aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fce7aa",
  null
  
)

export default component.exports